<div class="table-responsive table-loader">
  <table class="table">
    <thead>
      <tr>
        <th
          *ngFor="let column of [].constructor(columns); let i = index"
          class="skeleton"
        >
          {{ headers[i] || "" }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of [].constructor(rows)">
        <td
          *ngFor="let column of [].constructor(columns)"
          class="skeleton"
        ></td>
      </tr>
    </tbody>
  </table>
</div>
